module.exports = __webpack_public_path__ + "static/media/joyce.1c7e77be.jpg";